import { Answers } from "../../context/vulnerability/VulnerabilityContext";
interface PageContent {
  step: string;
  title: string;
  subTitle?: string;
  whyWeWantTextsCustomer?: string[];
}

export const questionContent: Record<keyof Answers, PageContent> = {
  children: {
    step: "Step 1 of 9",
    title: "Are you or anyone in your household pregnant or have children?",
    subTitle: "Please check all that apply.",
  },
  sight: {
    step: "Step 2 of 9",
    title: "Are you or anyone in your household visually impaired?",
    subTitle:
      "We're able to offer additional services to customers who may struggle to access their account information either on paper or via our website.",

    whyWeWantTextsCustomer: [
      `If you or anyone in your household is blind or partially sighted, we have a range of services that can be offered, including braille or large-print bills.`,
    ],
  },
  sightDetail: {
    step: "Step 2 of 9",
    title: "Please specify your level of visual impairment",
    subTitle: "Select all that apply to your household.",
  },
  hearing: {
    step: "Step 3 of 9",
    title: "Are you or anyone in your household deaf or hard of hearing?",
    subTitle:
      "We can offer customers that may struggle to use our call centres extra support.",

    whyWeWantTextsCustomer: [
      `If you or anyone in your household is deaf or hard of hearing, you may benefit from access to extra help such as free paper bills. We also offer SignVideo via our 'Contact us' page for customers wishing to use Sign Language.`,
    ],
  },
  age: {
    step: "Step 4 of 9",
    title: "Are you or anyone in your household past the retirement age?",
    subTitle:
      "The current pensionable (or retirement) age in the UK for both men and women is 66. However, if you or anyone in your household is younger and have already retired, please also select 'Yes' to this question.",

    whyWeWantTextsCustomer: [
      `If you or anyone in your household is retired or of pensionable age, you may benefit from access to extra help such as free paper bills.`,
    ],
  },
  ageDetail: {
    step: "Step 4 of 9",
    title: "How old are the people who have retired in your household?",
    subTitle:
      "If multiple people in the household are retired, select all that apply.",
  },
  ageCare: {
    step: "Step 4 of 9",
    title:
      "Is there anyone in the house who currently helps to care for the household member(s) of pensionable age?",
  },
  medicalEquipment: {
    step: "Step 5 of 9",
    title: "Is there any medical equipment in your house?",
    subTitle:
      "Understanding what affects our customers allows us to recommend additional services that may be of help.",
    whyWeWantTextsCustomer: [
      `If you or anyone in your household is reliant on medical equipment, it will help us understand, where you have a prepayment meter or you want to switch to one, whether it is suitable based on your circumstances.`,
    ],
  },
  medicalEquipmentDetail: {
    step: "Step 5 of 9",
    title:
      "Please select if you have any of the following medical equipment in your house",
    subTitle:
      "Understanding what affects our customers allows us to recommend additional services that may be of help.",

    whyWeWantTextsCustomer: [
      `If any of these apply to you or anyone in your household, you may benefit from extra help such as having your gas and electricity meters moved.`,
      "It will also help us understand, where you have a prepayment meter or you want to switch to one, whether it is suitable based on your circumstances.",
    ],
  },
  miscellaneous: {
    step: "Step 6 of 9",
    title: "Do any of the following apply to you or anyone in your household?",
    subTitle:
      "Understanding what affects our customers allows us to recommend additional services that may be of help.",

    whyWeWantTextsCustomer: [
      `If any of these apply to you or anyone in your household, you may benefit from extra help such as having your gas and electricity meters moved.`,
      "It will also help us understand, where you have a prepayment meter or you want to switch to one, whether it is suitable based on your circumstances.",
    ],
  },
  chronicIllness: {
    step: "Step 7 of 9",
    title:
      "Do you or anyone in your household live with a chronic serious illness?",
    subTitle:
      "Understanding what affects our customers allows us to recommend additional services that may be of help.",
  },
  chronicIllnessDetail: {
    step: "Step 7 of 9",
    title:
      "To make sure we can support you in the best possible way, please specify the chronic serious illness(es)",
  },
  financial: {
    step: "Step 8 of 9",
    title:
      "Are you or anyone in your household facing financial difficulties or hardships?",
    subTitle:
      "If you are struggling financially, we'll recommend services that can help.",

    whyWeWantTextsCustomer: [
      "If you or anyone in your household is experiencing financial stress, you may benefit from advice offered by charities and organisations who specialise in resolving financial concerns.",
    ],
  },
  financialDetail: {
    step: "Step 8 of 9",
    title:
      "Please let us know which of the following apply so we can help you in the best possible way",
  },
  dailyActivity: {
    step: "Additional questions",
    title:
      "Do your current circumstances make it difficult for you to manage essential daily activities like cooking, washing, cleaning, shopping etc.",

    whyWeWantTextsCustomer: [
      "Given your previous answers we require some extra information to understand your circumstances further.",
    ],
  },
  dailyActivityDetail: {
    step: "Additional questions",
    title: "",
  },
  dailySupport: {
    step: "Additional questions",
    title: "Do you have support on a daily basis to help you?",
    whyWeWantTextsCustomer: [
      "Given your previous answers we require some extra information to understand your circumstances further.",
    ],
  },
  dailySupportDetail: {
    step: "Additional questions",
    title: "",
  },
  psr: {
    step: "Additional questions",
    title: "",
  },
};
